"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableAttributeFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var model_1 = require("../../../model");
var AttributeFilterDropZoneHint_1 = require("./AttributeFilterDropZoneHint");
var useDashboardDrag_1 = require("../useDashboardDrag");
var legacyFilterConvertors_1 = require("../../../_staging/dashboard/legacyFilterConvertors");
function DraggableAttributeFilter(_a) {
    var FilterComponent = _a.FilterComponent, filter = _a.filter, filterIndex = _a.filterIndex, autoOpen = _a.autoOpen, onAttributeFilterChanged = _a.onAttributeFilterChanged, onAttributeFilterAdded = _a.onAttributeFilterAdded, onAttributeFilterClose = _a.onAttributeFilterClose;
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var _b = tslib_1.__read(useDashboardDrag_1.useDashboardDrag({
        dragItem: {
            type: "attributeFilter",
            filter: filter,
            filterIndex: filterIndex,
        },
        canDrag: isInEditMode,
    }, [filter, filterIndex, isInEditMode]), 2), isDragging = _b[0].isDragging, dragRef = _b[1];
    var supportElementUris = model_1.useDashboardSelector(model_1.selectSupportsElementUris);
    var canAddMoreAttributeFilters = model_1.useDashboardSelector(model_1.selectCanAddMoreAttributeFilters);
    var filterToUse = react_1.useMemo(function () {
        if (supportElementUris) {
            return filter;
        }
        return legacyFilterConvertors_1.convertDashboardAttributeFilterElementsUrisToValues(filter);
    }, [filter, supportElementUris]);
    var onClose = react_1.useCallback(function () {
        onAttributeFilterClose();
    }, [onAttributeFilterClose]);
    var showDropZones = isInEditMode && !isDragging;
    return (react_1.default.createElement("div", { className: "draggable-attribute-filter" },
        showDropZones ? (react_1.default.createElement(AttributeFilterDropZoneHint_1.AttributeFilterDropZoneHint, { hintPosition: "prev", targetIndex: filterIndex, onAddAttributePlaceholder: onAttributeFilterAdded, acceptPlaceholder: canAddMoreAttributeFilters })) : null,
        react_1.default.createElement("div", { className: classnames_1.default("dash-filters-notdate", "dash-filters-attribute", {
                "dash-filter-is-edit-mode": isInEditMode,
                "is-dragging": isDragging,
            }), ref: dragRef },
            react_1.default.createElement(FilterComponent, { filter: filterToUse, onFilterChanged: onAttributeFilterChanged, isDraggable: isInEditMode, autoOpen: autoOpen, onClose: onClose })),
        showDropZones ? (react_1.default.createElement(AttributeFilterDropZoneHint_1.AttributeFilterDropZoneHint, { hintPosition: "next", targetIndex: filterIndex, onAddAttributePlaceholder: onAttributeFilterAdded, acceptPlaceholder: canAddMoreAttributeFilters })) : null));
}
exports.DraggableAttributeFilter = DraggableAttributeFilter;
//# sourceMappingURL=DraggableAttributeFilter.js.map